import React from 'react';
import { ProductVariantSummaryProps } from '../interfaces';
import { formatVariantPrice } from '../../utils/variantSummary';
import './ProductVariantSummary.scss';

const ProductVariantSummary: React.FC<ProductVariantSummaryProps> = ({
  selectedVariantLabel,
  price,
  loading,
}) => (
  <div className="variant-summary" aria-live="polite">
    <div className="variant-summary__row">
      <span className="variant-summary__label">Selected variant</span>
      <span className="variant-summary__value">{selectedVariantLabel}</span>
    </div>
    <div className="variant-summary__row">
      <span className="variant-summary__label">Variant price</span>
      <span className="variant-summary__price">
        {loading ? 'Loading...' : formatVariantPrice(price)}
      </span>
    </div>
  </div>
);

export default ProductVariantSummary;
